// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CritiqueRouteImport } from './routes/critique'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FreeReviewRouteImport } from './routes/free-review'
import { Route as HomeV4RouteImport } from './routes/home-v4'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RedeemRouteImport } from './routes/redeem'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as StudentsRouteImport } from './routes/students'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VersusRouteImport } from './routes/versus'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAiBenchmarkRouteImport } from './routes/admin.ai-benchmark'
import { Route as AdminAiProviderRouteImport } from './routes/admin.ai-provider'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminCalibrationRouteImport } from './routes/admin.calibration'
import { Route as AdminChangeRequestsRouteImport } from './routes/admin.change-requests'
import { Route as AdminCodesRouteImport } from './routes/admin.codes'
import { Route as AdminDebugRouteImport } from './routes/admin.debug'
import { Route as AdminDocsRouteImport } from './routes/admin.docs'
import { Route as AdminInstitutionsRouteImport } from './routes/admin.institutions'
import { Route as AdminKgRouteImport } from './routes/admin.kg'
import { Route as AdminLandingRouteImport } from './routes/admin.landing'
import { Route as AdminPatternsRouteImport } from './routes/admin.patterns'
import { Route as AdminPolicyLinksRouteImport } from './routes/admin.policy-links'
import { Route as AdminReferencesRouteImport } from './routes/admin.references'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminSignalsRouteImport } from './routes/admin.signals'
import { Route as AdminTeamRouteImport } from './routes/admin.team'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ReviewsIndexRouteImport } from './routes/reviews.index'
import { Route as ReviewsReviewIdRouteImport } from './routes/reviews.$reviewId'
import { Route as ReviewsNewRouteImport } from './routes/reviews.new'
import { Route as AdminDevProgressMockupRouteImport } from './routes/admin.dev.progress-mockup'
import { Route as AdminReferencesIdRouteImport } from './routes/admin.references.$id'
import { Route as ReviewsReviewIdHybridRouteImport } from './routes/reviews_.$reviewId.hybrid'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const CritiqueRoute = CritiqueRouteImport.update({
            id: '/critique',path: '/critique',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FreeReviewRoute = FreeReviewRouteImport.update({
            id: '/free-review',path: '/free-review',getParentRoute: () => rootRouteImport
          })
const HomeV4Route = HomeV4RouteImport.update({
            id: '/home-v4',path: '/home-v4',getParentRoute: () => rootRouteImport
          })
const LibraryRoute = LibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const RedeemRoute = RedeemRouteImport.update({
            id: '/redeem',path: '/redeem',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const StudentsRoute = StudentsRouteImport.update({
            id: '/students',path: '/students',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VersusRoute = VersusRouteImport.update({
            id: '/versus',path: '/versus',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAiBenchmarkRoute = AdminAiBenchmarkRouteImport.update({
            id: '/ai-benchmark',path: '/ai-benchmark',getParentRoute: () => AdminRoute
          })
const AdminAiProviderRoute = AdminAiProviderRouteImport.update({
            id: '/ai-provider',path: '/ai-provider',getParentRoute: () => AdminRoute
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AdminRoute
          })
const AdminCalibrationRoute = AdminCalibrationRouteImport.update({
            id: '/calibration',path: '/calibration',getParentRoute: () => AdminRoute
          })
const AdminChangeRequestsRoute = AdminChangeRequestsRouteImport.update({
            id: '/change-requests',path: '/change-requests',getParentRoute: () => AdminRoute
          })
const AdminCodesRoute = AdminCodesRouteImport.update({
            id: '/codes',path: '/codes',getParentRoute: () => AdminRoute
          })
const AdminDebugRoute = AdminDebugRouteImport.update({
            id: '/debug',path: '/debug',getParentRoute: () => AdminRoute
          })
const AdminDocsRoute = AdminDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => AdminRoute
          })
const AdminInstitutionsRoute = AdminInstitutionsRouteImport.update({
            id: '/institutions',path: '/institutions',getParentRoute: () => AdminRoute
          })
const AdminKgRoute = AdminKgRouteImport.update({
            id: '/kg',path: '/kg',getParentRoute: () => AdminRoute
          })
const AdminLandingRoute = AdminLandingRouteImport.update({
            id: '/landing',path: '/landing',getParentRoute: () => AdminRoute
          })
const AdminPatternsRoute = AdminPatternsRouteImport.update({
            id: '/patterns',path: '/patterns',getParentRoute: () => AdminRoute
          })
const AdminPolicyLinksRoute = AdminPolicyLinksRouteImport.update({
            id: '/policy-links',path: '/policy-links',getParentRoute: () => AdminRoute
          })
const AdminReferencesRoute = AdminReferencesRouteImport.update({
            id: '/references',path: '/references',getParentRoute: () => AdminRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRoute
          })
const AdminSignalsRoute = AdminSignalsRouteImport.update({
            id: '/signals',path: '/signals',getParentRoute: () => AdminRoute
          })
const AdminTeamRoute = AdminTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ReviewsIndexRoute = ReviewsIndexRouteImport.update({
            id: '/reviews/',path: '/reviews/',getParentRoute: () => rootRouteImport
          })
const ReviewsReviewIdRoute = ReviewsReviewIdRouteImport.update({
            id: '/reviews/$reviewId',path: '/reviews/$reviewId',getParentRoute: () => rootRouteImport
          })
const ReviewsNewRoute = ReviewsNewRouteImport.update({
            id: '/reviews/new',path: '/reviews/new',getParentRoute: () => rootRouteImport
          })
const AdminDevProgressMockupRoute = AdminDevProgressMockupRouteImport.update({
            id: '/dev/progress-mockup',path: '/dev/progress-mockup',getParentRoute: () => AdminRoute
          })
const AdminReferencesIdRoute = AdminReferencesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminReferencesRoute
          })
const ReviewsReviewIdHybridRoute = ReviewsReviewIdHybridRouteImport.update({
            id: '/reviews_/$reviewId/hybrid',path: '/reviews/$reviewId/hybrid',getParentRoute: () => rootRouteImport
          })





const AdminReferencesRouteChildren = {
  AdminReferencesIdRoute: AdminReferencesIdRoute
}

const AdminReferencesRouteWithChildren = AdminReferencesRoute._addFileChildren(AdminReferencesRouteChildren)



const AdminRouteChildren = {
  AdminAiBenchmarkRoute: AdminAiBenchmarkRoute,AdminAiProviderRoute: AdminAiProviderRoute,AdminAuditRoute: AdminAuditRoute,AdminCalibrationRoute: AdminCalibrationRoute,AdminChangeRequestsRoute: AdminChangeRequestsRoute,AdminCodesRoute: AdminCodesRoute,AdminDebugRoute: AdminDebugRoute,AdminDocsRoute: AdminDocsRoute,AdminInstitutionsRoute: AdminInstitutionsRoute,AdminKgRoute: AdminKgRoute,AdminLandingRoute: AdminLandingRoute,AdminPatternsRoute: AdminPatternsRoute,AdminPolicyLinksRoute: AdminPolicyLinksRoute,AdminReferencesRoute: AdminReferencesRouteWithChildren,AdminReportsRoute: AdminReportsRoute,AdminSignalsRoute: AdminSignalsRoute,AdminTeamRoute: AdminTeamRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute,AdminDevProgressMockupRoute: AdminDevProgressMockupRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,CritiqueRoute: CritiqueRoute,DashboardRoute: DashboardRoute,FaqRoute: FaqRoute,FreeReviewRoute: FreeReviewRoute,HomeV4Route: HomeV4Route,LibraryRoute: LibraryRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,ProfileRoute: ProfileRoute,RedeemRoute: RedeemRoute,SettingsRoute: SettingsRoute,SignupRoute: SignupRoute,StudentsRoute: StudentsRoute,TermsRoute: TermsRoute,VersusRoute: VersusRoute,AuthCallbackRoute: AuthCallbackRoute,BlogSlugRoute: BlogSlugRoute,ReviewsReviewIdRoute: ReviewsReviewIdRoute,ReviewsNewRoute: ReviewsNewRoute,BlogIndexRoute: BlogIndexRoute,ReviewsIndexRoute: ReviewsIndexRoute,ReviewsReviewIdHybridRoute: ReviewsReviewIdHybridRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)